import Invoices from '@/views/invoices/invoices-list.vue'
import { InvoicesRouteNames } from '@/router/routes-names'

export const invoicesRoutes = [
    {
        path: '/invoices/',
        name: InvoicesRouteNames.LIST,
        component: Invoices
    }
]
